export default __webpack_public_path__ + "static/media/background.17d65e33.png";